module.exports = __webpack_public_path__ + "img/7 2B.05702b7b.05702b7b.png";